import Vue from 'vue'
import {
        Message,
        Carousel,
        CarouselItem,
        Image,
        Input,
        Pagination,
        Tabs,
        TabPane,
        Table,
        TableColumn} from 'element-ui'

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)

Vue.prototype.$message = Message
